import round from 'lodash/round';
import {NUM_FRACTION_DIGITS} from '@PosterWhiteboard/common.types';
import {IntroAnimation} from '@PosterWhiteboard/animation/intro-animation.class';
import {isWipeOrBlockAnimation} from '@PosterWhiteboard/animation/animation.class';
import type {SlideItem} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.types';

interface PositionAndScale {
  x: number;
  y: number;
  scaleX: number;
  scaleY: number;
}

export function getStaticSlideValues(slide: SlideItem): PositionAndScale {
  let scaleX = slide.getScaleX();
  let scaleY = slide.getScaleY();
  let x = slide.getX();
  let y = slide.getY();

  const animation = slide.slideshow.animation;
  // in case of block & wipe, startingAnimationValues/endingAnimationValues are applied to block & clipPath and not slide's fabric object (opacity is applied to fabricObject in block though)
  // opacity isn't being used here, but if it were, it should get it from viewComponentOpacitySnapshot for block animation
  if (slide.slideshow.isSlideshowAnimationPlaying && animation && !isWipeOrBlockAnimation(animation.type) && slide.slideshow.animation?.item.fabricObject === slide.fabricObject) {
    if (slide.slideshow.animation instanceof IntroAnimation) {
      if ('scaleX' in slide.slideshow.animation.onCompleteValues) {
        scaleX = slide.slideshow.animation.onCompleteValues.scaleX;
      }
      if ('scaleY' in slide.slideshow.animation.onCompleteValues) {
        scaleY = slide.slideshow.animation.onCompleteValues.scaleY;
      }
      if ('left' in slide.slideshow.animation.onCompleteValues) {
        x = slide.slideshow.animation.onCompleteValues.left;
      }
      if ('top' in slide.slideshow.animation.onCompleteValues) {
        y = slide.slideshow.animation.onCompleteValues.top;
      }
    } else {
      if ('scaleX' in slide.slideshow.animation.startingAnimationValues) {
        scaleX = slide.slideshow.animation.startingAnimationValues.scaleX;
      }
      if ('scaleY' in slide.slideshow.animation.startingAnimationValues) {
        scaleY = slide.slideshow.animation.startingAnimationValues.scaleY;
      }
      if ('left' in slide.slideshow.animation.startingAnimationValues) {
        x = slide.slideshow.animation.startingAnimationValues.left;
      }
      if ('top' in slide.slideshow.animation.startingAnimationValues) {
        y = slide.slideshow.animation.startingAnimationValues.top;
      }
    }
  }

  return {
    x: round(x, NUM_FRACTION_DIGITS),
    y: round(y, NUM_FRACTION_DIGITS),
    scaleX: round(scaleX, NUM_FRACTION_DIGITS),
    scaleY: round(scaleY, NUM_FRACTION_DIGITS),
  };
}
